import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface MoreIconPropsType {
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<MoreIconPropsType>`
    height: auto;
`;

export const MoreIconCMS = observer('MoreIcon', ({ className, onClick }: MoreIconPropsType): React.ReactElement => {
    return (
        <SvgElement
            className={className}
            onClick={onClick}
            width='16'
            height='16'
            fill='none'
            viewBox='0 0 16 16'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g id='dots-vertical'>
                <path
                    id='Vector'
                    d='M8.70005 2.66667C8.70005 3.05327 8.38665 3.36667 8.00005 3.36667C7.61345 3.36667 7.30005 3.05327 7.30005 2.66667C7.30005 2.28008 7.61345 1.96667 8.00005 1.96667C8.38665 1.96667 8.70005 2.28008 8.70005 2.66667ZM8.70005 8.00001C8.70005 8.38661 8.38665 8.70001 8.00005 8.70001C7.61345 8.70001 7.30005 8.38661 7.30005 8.00001C7.30005 7.61341 7.61345 7.30001 8.00005 7.30001C8.38665 7.30001 8.70005 7.61341 8.70005 8.00001ZM8.70005 13.3333C8.70005 13.7199 8.38664 14.0333 8.00005 14.0333C7.61346 14.0333 7.30005 13.7199 7.30005 13.3333C7.30005 12.9468 7.61346 12.6333 8.00005 12.6333C8.38664 12.6333 8.70005 12.9468 8.70005 13.3333Z'
                    fill='#0F172A'
                    stroke='#0F172A'
                />
            </g>
        </SvgElement>
    );
});
